import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BranchesService } from 'src/app/services/branches.service';
import { ExchangeService } from 'src/app/services/exchange.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-historico-branch',
  templateUrl: './historico-branch.component.html',
  styleUrls: ['./historico-branch.component.scss'],
})
export class HistoricoBranchComponent implements OnInit, OnDestroy {
  public sucursal: any;
  public sucursalId: any;
  public historialDolar: any;
  public dolarActual: any = 0;
  public dolarAnterior: any = 0;
  public porcentaje: string = '';
  public icon: any;
  public sucursales: any;
  public isCollapse: boolean = true;
  public isDesktop: boolean = true;

  private branchIdSub?: Subscription;
  private branchesLoadSub?: Subscription;

  constructor(
    private readonly _exchangeService: ExchangeService,
    private readonly _branchService: BranchesService,
    private readonly _router: Router,
    private readonly deviceService: DeviceDetectorService,
    private readonly _translate: TranslateService,
  ) {
    this.setDollarPercentLabel('0');
  }

  ngOnInit(): void {
    this.sucursal = JSON.parse(localStorage.getItem('branch') || '{}');
    this.sucursalId = Number.parseInt(localStorage.getItem('branchId') || '0');

    this.branchesLoadSub = this._branchService.getAll().subscribe({
      next: (branches: any) => {
        this.sucursales = branches;
        this.sucursal = this.sucursales.find(
          (value: any) => value.id == this.sucursalId,
        );
      },
    });

    this.isDesktop = this.deviceService.isDesktop();
    if (this.isDesktop) {
      this.isCollapse = false;
    }

    this.getBranchHistory();

    this.branchIdSub = this._branchService.sucursalId.subscribe((data: any) => {
      if (data == 0) {
        return;
      }

      if (data) {
        this.sucursalId = data;
        this.sucursal = this.sucursales?.find((value: any) => value.id == data);

        localStorage.setItem('branch', JSON.stringify(this.sucursal));
        localStorage.setItem('branchId', data.toString());

        setTimeout(() => {
          this.getBranchHistory();
        }, 1000);
      }
    });
  }

  ngOnDestroy(): void {
    this.branchIdSub?.unsubscribe();
    this.branchesLoadSub?.unsubscribe();
  }

  goToGraficas() {
    void this._router.navigateByUrl('/app/graficas');
  }

  getBranchHistory() {
    this._exchangeService.getCurrencies().subscribe((currencies) => {
      const usdCurrency = currencies.find((c) => c.code === 'USD');
      if (!usdCurrency) return;

      const dateFormat = 'DD-MM-YYYY';
      const endDate = moment().format(dateFormat);
      const startDate = moment().subtract(1, 'days').format(dateFormat);

      this._exchangeService
        .getExchangeHistory(this.sucursalId, usdCurrency.id, startDate, endDate)
        .subscribe((history) => {
          if (!history || history.length === 0) return;

          this.historialDolar = history.map((h) => ({
            ...h,
            buy: parseFloat(h.buyPrice),
            sell: parseFloat(h.sellPrice),
          }));

          if (this.historialDolar.length > 0) {
            this.dolarActual =
              this.historialDolar[this.historialDolar.length - 1];
          }

          if (this.historialDolar.length > 1) {
            this.dolarAnterior =
              this.historialDolar[this.historialDolar.length - 2];
          } else {
            this.dolarAnterior = this.dolarActual;
          }

          if (this.dolarAnterior.buy === 0) {
            this.setDollarPercentLabel('0');
            this.icon = 'remove';
            return;
          }

          const variacion =
            ((this.dolarActual.buy - this.dolarAnterior.buy) /
              this.dolarAnterior.buy) *
            100;

          this.setDollarPercentLabel(Math.abs(variacion).toFixed(3));

          if (variacion > 0) {
            this.icon = 'arrow_drop_up';
          } else if (variacion < 0) {
            this.icon = 'arrow_drop_down';
          } else {
            this.icon = 'remove';
          }
        });
    });
  }

  collapseAction() {
    this.isCollapse = !this.isCollapse;
  }

  getBranchPhone() {
    return this.sucursal?.contacts?.find(
      (contact: any) => contact.type === 'PHONE',
    )?.value;
  }

  getBranchWhatsapp() {
    return this.sucursal?.contacts?.find(
      (contact: any) => contact.type === 'WHATSAPP',
    )?.value;
  }

  private setDollarPercentLabel(percent: string): void {
    this._translate
      .get('HISTORICO_BRANCH.DOLAR_PERCENT', { percent })
      .subscribe((translation) => {
        this.porcentaje = translation;
      });
  }
}
